var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',[_vm._v("Use this account?")]),_c('p',[_vm._v("Email: "+_vm._s(_vm.profile.email))]),_c('b-button',{class:{ 'spinner spinner-light spinner-right': _vm.isBusy === true },attrs:{"variant":"primary","block":""},on:{"click":_vm.complete}},[_vm._v("Verify")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }